import { useEffect, useRef } from 'react';

import { useIsInView } from '@hooks/useIsInView';
import { useTrackingContext } from '@tracking/Provider/Context';
import { useTrackSignupContractExpiryDatePromoDisplayedOnce } from '@tracking/trackingEvents';

import { RenewalCaptureForm } from './RenewalCaptureForm';

export const MobileRenewal = () => {
  const formRef = useRef<HTMLDivElement>(null);
  const isInView = useIsInView(formRef);

  const { trackingContexts } = useTrackingContext();
  const trackPromoDisplayed =
    useTrackSignupContractExpiryDatePromoDisplayedOnce();

  useEffect(() => {
    if (isInView) {
      trackPromoDisplayed(
        { product: 'Mobile' },
        { contexts: trackingContexts }
      );
    }
  }, [isInView, trackPromoDisplayed, trackingContexts]);

  return (
    <RenewalCaptureForm
      field="renewalMobileDate"
      ref={formRef}
      label="Mobile SIM contract end date"
    />
  );
};
